var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("h1", [_vm._v("Marketing")]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { id: "myForm" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.send()
          },
        },
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "inputText" } }, [
            _vm._v("Que voulez vous faire ?"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.message,
                expression: "message",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              id: "inputText",
              placeholder: "Une promotion ...",
            },
            domProps: { value: _vm.message },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.message = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [
            _vm._v("Envoyer "),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.processing,
                  expression: "processing",
                },
              ],
              staticClass: "loading",
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "history" } }, [
      _c("h2", [_vm._v("Historique")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-group", attrs: { id: "historyList" } },
        _vm._l(_vm.messages, function (message, i) {
          return _c(
            "div",
            { key: i, staticClass: "list-group-item color-black" },
            [_vm._v("\n                " + _vm._s(message) + "\n            ")]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }